export const environment = { production: false };



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/demo/environments/environment.ts